import React from "react";
import laptop from "../assets/laptop.png"

export default function HeroSection() {
  return (
    <section className="bg-white pb-14">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center max-sm:mt-0 max-lg:mt-10">
          <div className="max-md:order-2 max-md:text-center">
            <h1 className=" text-4xl md:text-5xl font-bold leading-tight text-slate-900">
              Elevate Your Game <br />
              <span className="text-[#7533AF]">&amp; </span>
               Food Business
            </h1>

            <p className="mt-8 text-slate-600 text-sm md:text-base max-w-lg">
              Manage unlimited game tables, food inventory, staff, and <br/> finances all
              in one powerful platform. Streamline operations and maximize revenue.
            </p>

            <div className="mt-8 flex items-center gap-3 max-md:justify-center">
              <button className="rounded-lg bg-[#7533AF] px-5 py-2 text-sm font-semibold text-white hover:opacity-90 shadow-sm">
                Start Free Trial
              </button>
              <button className="rounded-lg border border-[#7533AF] px-5 py-2 text-sm font-semibold text-[#7533AF] hover:bg-[#7533AF]/10">
                Watch Demo
              </button>
            </div>
          </div>

          <div className="flex justify-center max-md:order-1">
            <img
              src={laptop}
              alt="Dashboard preview"
              className="w-full max-w-md md:max-w-lg md:w-[90%] drop-shadow-[0_20px_35px_rgba(0,0,0,0.15)]"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />

            {/* fallback block if image missing */}
            {/* <div className="w-full max-w-md md:max-w-lg aspect-[4/3] flex items-center justify-center text-slate-400 text-sm">
              <img
              src={laptop}
              alt="Imdady"
              // className="h-8 w-auto"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
